import { gql } from '@apollo/client';

import {
  FirstToDonateEnrolmentFragment,
  PageType,
} from '../../types/__generated__';
import { PageMetaContext } from '../context';
import useBasePageQuery from './useBasePageQuery';
import { useNotNullableContext } from './useNotNullableContext';
import usePageQuery, { buildQuery } from './usePageQuery';

const FRAGMENT = buildQuery(gql`
  fragment FirstToDonateEnrolment on Page {
    id
    targetWithCurrency {
      currencyCode
      value
    }
  }
`);

export function useShouldDisplayFirstToDonateTotals(): boolean {
  const { pageType } = useNotNullableContext(PageMetaContext);

  const { data = null } = usePageQuery<FirstToDonateEnrolmentFragment>(
    FRAGMENT,
    {
      notifyOnNetworkStatusChange: true,
    },
  );
  const { data: basePageData } = useBasePageQuery();

  if (!data || !basePageData?.page) return false;

  const { targetWithCurrency } = data;

  const targetValue = targetWithCurrency?.value;
  const donationValue =
    basePageData.page.donationSummary?.totalAmount?.value ?? 0;

  return !(
    pageType.toUpperCase() !== PageType.Fundraising ||
    !targetValue ||
    donationValue > 0
  );
}
